// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file driver_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContainerStatusUpdateSchema } from "./container_pb";
import { file_container } from "./container_pb";
import type { DriverIncidentSchema, DriverIncidentType, DriverIncidentTypeJson } from "./driver_incident_pb";
import { file_driver_incident } from "./driver_incident_pb";
import type { DriverOnShift, DriverOnShiftJson, DriverOnShiftSchema } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { File, FileJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { DateTimeFilterSchema, EmptyMessageRequestSchema, IdRequestSchema, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JobFileUploadRequestSchema, JobListSchema, JobSchema } from "./job_pb";
import { file_job } from "./job_pb";
import type { LocationListRequestSchema, LocationListSchema } from "./location_pb";
import { file_location } from "./location_pb";
import type { PickupLocationListSchema } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { Route, RouteJson, RouteListSchema, RouteSchema } from "./route_pb";
import { file_route } from "./route_pb";
import type { ShiftScheduleCell, ShiftScheduleCellJson } from "./shift_plan_service_pb";
import { file_shift_plan_service } from "./shift_plan_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file driver_service.proto.
 */
export const file_driver_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_container, file_driver_incident, file_driver_on_shift, file_file_upload, file_general, file_google_protobuf_timestamp, file_job, file_location, file_pickup_location, file_route, file_shift_plan_service]);

/**
 * @generated from message raccoonai.MyLocationRequest
 */
export type MyLocationRequest = Message<"raccoonai.MyLocationRequest"> & {
  /**
   * @generated from field: required double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: required double lon = 2;
   */
  lon: number;

  /**
   * @generated from field: optional double accuracy = 3;
   */
  accuracy: number;

  /**
   * @generated from field: optional double altitude = 4;
   */
  altitude: number;

  /**
   * @generated from field: optional double heading = 5;
   */
  heading: number;

  /**
   * @generated from field: optional double speed = 6;
   */
  speed: number;

  /**
   * @generated from field: optional uint64 current_route_id = 7 [json_name = "route_id"];
   */
  currentRouteId: bigint;

  /**
   * @generated from field: optional uint64 current_job_id = 8 [json_name = "job_id"];
   */
  currentJobId: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp sent_at = 9 [json_name = "sent_at"];
   */
  sentAt?: Timestamp;
};

/**
 * @generated from message raccoonai.MyLocationRequest
 */
export type MyLocationRequestJson = {
  /**
   * @generated from field: required double lat = 1;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lon = 2;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double accuracy = 3;
   */
  accuracy?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double altitude = 4;
   */
  altitude?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double heading = 5;
   */
  heading?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double speed = 6;
   */
  speed?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 current_route_id = 7 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional uint64 current_job_id = 8 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp sent_at = 9 [json_name = "sent_at"];
   */
  sent_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.MyLocationRequest.
 * Use `create(MyLocationRequestSchema)` to create a new message.
 */
export const MyLocationRequestSchema: GenMessage<MyLocationRequest, {jsonType: MyLocationRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 0);

/**
 * Shared request for ReportShiftIncident and ReportJobIncident. The reporting
 * context (shift vs job) is expressed by which RPC is called, not by a field —
 * each RPC has its own preconditions, allowed types, and side effects.
 *
 * @generated from message raccoonai.ReportIncidentRequest
 */
export type ReportIncidentRequest = Message<"raccoonai.ReportIncidentRequest"> & {
  /**
   * @generated from field: required raccoonai.DriverIncidentType type = 1;
   */
  type: DriverIncidentType;

  /**
   * Optional photo/video evidence: the breakdown or accident scene on shift,
   * the blocked pickup location on a job (proof that the pickup was impossible).
   *
   * @generated from field: repeated raccoonai.File files = 2;
   */
  files: File[];

  /**
   * The job the report is about, for ReportJobIncident. Must be a job that is
   * currently in progress on the driver's active route — a stale or foreign id
   * is rejected rather than silently replaced. Omit to let the backend use the
   * driver's current job. Ignored by ReportShiftIncident.
   *
   * @generated from field: optional uint64 job_id = 3 [json_name = "job_id"];
   */
  jobId: bigint;
};

/**
 * Shared request for ReportShiftIncident and ReportJobIncident. The reporting
 * context (shift vs job) is expressed by which RPC is called, not by a field —
 * each RPC has its own preconditions, allowed types, and side effects.
 *
 * @generated from message raccoonai.ReportIncidentRequest
 */
export type ReportIncidentRequestJson = {
  /**
   * @generated from field: required raccoonai.DriverIncidentType type = 1;
   */
  type?: DriverIncidentTypeJson;

  /**
   * Optional photo/video evidence: the breakdown or accident scene on shift,
   * the blocked pickup location on a job (proof that the pickup was impossible).
   *
   * @generated from field: repeated raccoonai.File files = 2;
   */
  files?: FileJson[];

  /**
   * The job the report is about, for ReportJobIncident. Must be a job that is
   * currently in progress on the driver's active route — a stale or foreign id
   * is rejected rather than silently replaced. Omit to let the backend use the
   * driver's current job. Ignored by ReportShiftIncident.
   *
   * @generated from field: optional uint64 job_id = 3 [json_name = "job_id"];
   */
  job_id?: string;
};

/**
 * Describes the message raccoonai.ReportIncidentRequest.
 * Use `create(ReportIncidentRequestSchema)` to create a new message.
 */
export const ReportIncidentRequestSchema: GenMessage<ReportIncidentRequest, {jsonType: ReportIncidentRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 1);

/**
 * @generated from message raccoonai.ChoosePickupLocationRequest
 */
export type ChoosePickupLocationRequest = Message<"raccoonai.ChoosePickupLocationRequest"> & {
  /**
   * Deprecated: choose every job at this pickup location, standing any other
   * ENROUTE job down. Kept, under the field number and JSON name of the
   * IdRequest it replaces, for app versions that still send it; ignored when
   * job_ids is set.
   *
   * @generated from field: optional uint64 id = 1;
   */
  id: bigint;

  /**
   * The jobs of the active route the driver is heading to.
   *
   * @generated from field: repeated uint64 job_ids = 2 [json_name = "job_ids"];
   */
  jobIds: bigint[];
};

/**
 * @generated from message raccoonai.ChoosePickupLocationRequest
 */
export type ChoosePickupLocationRequestJson = {
  /**
   * Deprecated: choose every job at this pickup location, standing any other
   * ENROUTE job down. Kept, under the field number and JSON name of the
   * IdRequest it replaces, for app versions that still send it; ignored when
   * job_ids is set.
   *
   * @generated from field: optional uint64 id = 1;
   */
  id?: string;

  /**
   * The jobs of the active route the driver is heading to.
   *
   * @generated from field: repeated uint64 job_ids = 2 [json_name = "job_ids"];
   */
  job_ids?: string[];
};

/**
 * Describes the message raccoonai.ChoosePickupLocationRequest.
 * Use `create(ChoosePickupLocationRequestSchema)` to create a new message.
 */
export const ChoosePickupLocationRequestSchema: GenMessage<ChoosePickupLocationRequest, {jsonType: ChoosePickupLocationRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 2);

/**
 * @generated from message raccoonai.CompleteCurrentJobRequest
 */
export type CompleteCurrentJobRequest = Message<"raccoonai.CompleteCurrentJobRequest"> & {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;
};

/**
 * @generated from message raccoonai.CompleteCurrentJobRequest
 */
export type CompleteCurrentJobRequestJson = {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;
};

/**
 * Describes the message raccoonai.CompleteCurrentJobRequest.
 * Use `create(CompleteCurrentJobRequestSchema)` to create a new message.
 */
export const CompleteCurrentJobRequestSchema: GenMessage<CompleteCurrentJobRequest, {jsonType: CompleteCurrentJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 3);

/**
 * @generated from message raccoonai.FirebaseNotificationsRequest
 */
export type FirebaseNotificationsRequest = Message<"raccoonai.FirebaseNotificationsRequest"> & {
  /**
   * @generated from field: required bool subscribe = 1;
   */
  subscribe: boolean;

  /**
   * @generated from field: optional string fcm_token = 2 [json_name = "fcm_token"];
   */
  fcmToken: string;
};

/**
 * @generated from message raccoonai.FirebaseNotificationsRequest
 */
export type FirebaseNotificationsRequestJson = {
  /**
   * @generated from field: required bool subscribe = 1;
   */
  subscribe?: boolean;

  /**
   * @generated from field: optional string fcm_token = 2 [json_name = "fcm_token"];
   */
  fcm_token?: string;
};

/**
 * Describes the message raccoonai.FirebaseNotificationsRequest.
 * Use `create(FirebaseNotificationsRequestSchema)` to create a new message.
 */
export const FirebaseNotificationsRequestSchema: GenMessage<FirebaseNotificationsRequest, {jsonType: FirebaseNotificationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 4);

/**
 * TODO: define response message properly
 * Does it need to return topic/token info?
 *
 * @generated from message raccoonai.FirebaseNotificationsResponse
 */
export type FirebaseNotificationsResponse = Message<"raccoonai.FirebaseNotificationsResponse"> & {
  /**
   * @generated from field: required bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: optional string message = 2;
   */
  message: string;
};

/**
 * TODO: define response message properly
 * Does it need to return topic/token info?
 *
 * @generated from message raccoonai.FirebaseNotificationsResponse
 */
export type FirebaseNotificationsResponseJson = {
  /**
   * @generated from field: required bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;
};

/**
 * Describes the message raccoonai.FirebaseNotificationsResponse.
 * Use `create(FirebaseNotificationsResponseSchema)` to create a new message.
 */
export const FirebaseNotificationsResponseSchema: GenMessage<FirebaseNotificationsResponse, {jsonType: FirebaseNotificationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 5);

/**
 * @generated from message raccoonai.MyShiftScheduleRequest
 */
export type MyShiftScheduleRequest = Message<"raccoonai.MyShiftScheduleRequest"> & {
  /**
   * @generated from field: required uint32 year = 1;
   */
  year: number;

  /**
   * 1-12
   *
   * @generated from field: required uint32 month = 2;
   */
  month: number;
};

/**
 * @generated from message raccoonai.MyShiftScheduleRequest
 */
export type MyShiftScheduleRequestJson = {
  /**
   * @generated from field: required uint32 year = 1;
   */
  year?: number;

  /**
   * 1-12
   *
   * @generated from field: required uint32 month = 2;
   */
  month?: number;
};

/**
 * Describes the message raccoonai.MyShiftScheduleRequest.
 * Use `create(MyShiftScheduleRequestSchema)` to create a new message.
 */
export const MyShiftScheduleRequestSchema: GenMessage<MyShiftScheduleRequest, {jsonType: MyShiftScheduleRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 6);

/**
 * @generated from message raccoonai.DriverShiftSchedule
 */
export type DriverShiftSchedule = Message<"raccoonai.DriverShiftSchedule"> & {
  /**
   * @generated from field: required string today = 1;
   */
  today: string;

  /**
   * @generated from field: repeated raccoonai.ShiftScheduleCell cells = 2;
   */
  cells: ShiftScheduleCell[];

  /**
   * @generated from field: required uint32 month_total = 3 [json_name = "month_total"];
   */
  monthTotal: number;
};

/**
 * @generated from message raccoonai.DriverShiftSchedule
 */
export type DriverShiftScheduleJson = {
  /**
   * @generated from field: required string today = 1;
   */
  today?: string;

  /**
   * @generated from field: repeated raccoonai.ShiftScheduleCell cells = 2;
   */
  cells?: ShiftScheduleCellJson[];

  /**
   * @generated from field: required uint32 month_total = 3 [json_name = "month_total"];
   */
  month_total?: number;
};

/**
 * Describes the message raccoonai.DriverShiftSchedule.
 * Use `create(DriverShiftScheduleSchema)` to create a new message.
 */
export const DriverShiftScheduleSchema: GenMessage<DriverShiftSchedule, {jsonType: DriverShiftScheduleJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 7);

/**
 * One planned shift with the work planned on it.
 *
 * @generated from message raccoonai.PlannedShift
 */
export type PlannedShift = Message<"raccoonai.PlannedShift"> & {
  /**
   * The shift, with its truck and the truck's latest GPS position
   * (truck.latest_position).
   *
   * @generated from field: required raccoonai.DriverOnShift driver_on_shift = 1 [json_name = "driver_on_shift"];
   */
  driverOnShift?: DriverOnShift;

  /**
   * The shift's not-finished routes, oldest plan_start_at first, with
   * source/destination coordinates and their jobs; each job carries its
   * pickup_location (lat, lon, address), container type and container group.
   * route.driver_on_shift is left out: it is the shift above.
   *
   * @generated from field: repeated raccoonai.Route routes = 2;
   */
  routes: Route[];
};

/**
 * One planned shift with the work planned on it.
 *
 * @generated from message raccoonai.PlannedShift
 */
export type PlannedShiftJson = {
  /**
   * The shift, with its truck and the truck's latest GPS position
   * (truck.latest_position).
   *
   * @generated from field: required raccoonai.DriverOnShift driver_on_shift = 1 [json_name = "driver_on_shift"];
   */
  driver_on_shift?: DriverOnShiftJson;

  /**
   * The shift's not-finished routes, oldest plan_start_at first, with
   * source/destination coordinates and their jobs; each job carries its
   * pickup_location (lat, lon, address), container type and container group.
   * route.driver_on_shift is left out: it is the shift above.
   *
   * @generated from field: repeated raccoonai.Route routes = 2;
   */
  routes?: RouteJson[];
};

/**
 * Describes the message raccoonai.PlannedShift.
 * Use `create(PlannedShiftSchema)` to create a new message.
 */
export const PlannedShiftSchema: GenMessage<PlannedShift, {jsonType: PlannedShiftJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 8);

/**
 * Response of DriverService.MyPlannedShifts.
 *
 * @generated from message raccoonai.PlannedShiftList
 */
export type PlannedShiftList = Message<"raccoonai.PlannedShiftList"> & {
  /**
   * Oldest tw_start_at first.
   *
   * @generated from field: repeated raccoonai.PlannedShift planned_shifts = 1 [json_name = "planned_shifts"];
   */
  plannedShifts: PlannedShift[];
};

/**
 * Response of DriverService.MyPlannedShifts.
 *
 * @generated from message raccoonai.PlannedShiftList
 */
export type PlannedShiftListJson = {
  /**
   * Oldest tw_start_at first.
   *
   * @generated from field: repeated raccoonai.PlannedShift planned_shifts = 1 [json_name = "planned_shifts"];
   */
  planned_shifts?: PlannedShiftJson[];
};

/**
 * Describes the message raccoonai.PlannedShiftList.
 * Use `create(PlannedShiftListSchema)` to create a new message.
 */
export const PlannedShiftListSchema: GenMessage<PlannedShiftList, {jsonType: PlannedShiftListJson}> = /*@__PURE__*/
  messageDesc(file_driver_service, 9);

/**
 * @generated from service raccoonai.DriverService
 */
export const DriverService: GenService<{
  /**
   * @generated from rpc raccoonai.DriverService.MyShift
   */
  myShift: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverService.MyShiftSchedule
   */
  myShiftSchedule: {
    methodKind: "unary";
    input: typeof MyShiftScheduleRequestSchema;
    output: typeof DriverShiftScheduleSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverService.SendMyLocation
   */
  sendMyLocation: {
    methodKind: "unary";
    input: typeof MyLocationRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Start shift. Changes driver status to ACTIVE.
   *
   * @generated from rpc raccoonai.DriverService.StartShift
   */
  startShift: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * The calling driver's planned (NOT_APPROVED) shifts whose window has not
   * ended yet, with their routes and jobs. Fails with
   * ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY while the driver already has an
   * active shift: IDLE (approved, start it with StartShift), ACTIVE, ENROUTE
   * or ON_SERVICE.
   *
   * @generated from rpc raccoonai.DriverService.MyPlannedShifts
   */
  myPlannedShifts: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof PlannedShiftListSchema;
  },
  /**
   * Activate one of the calling driver's planned shifts without a dispatcher's
   * approval: NOT_APPROVED -> ACTIVE (an IDLE shift is started with StartShift).
   * Rejected when the shift's window has ended, the truck is not ACTIVE or
   * is busy on another shift, or the driver is already on another shift.
   * Whether tw_start_at has been reached is left to the client.
   *
   * @generated from rpc raccoonai.DriverService.ActivatePlannedShift
   */
  activatePlannedShift: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * Choose route from the list of assigned routes
   * Changes route status to IN_PROGRESS
   *
   * @generated from rpc raccoonai.DriverService.ChooseRoute
   */
  chooseRoute: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * Choose jobs of the active route the driver is heading to: they become
   * ENROUTE. Jobs already ENROUTE or ON_SERVICE elsewhere keep their status, so
   * the driver can have several pickup locations open at once, in any order.
   * Returns the chosen jobs.
   *
   * @generated from rpc raccoonai.DriverService.ChoosePickupLocation
   */
  choosePickupLocation: {
    methodKind: "unary";
    input: typeof ChoosePickupLocationRequestSchema;
    output: typeof JobListSchema;
  },
  /**
   * Get current assigned route and it's jobs. Can be used by driver app to
   * refresh the screen after app restart or network failure.
   *
   * @generated from rpc raccoonai.DriverService.GetCurrentRoute
   */
  getCurrentRoute: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * Pickup locations of the active route that can be serviced without leaving
   * the one already open — a pickup location can be a whole street, and stops
   * passed while driving along it belong to the same visit. Empty while the
   * driver has nothing ON_SERVICE.
   *
   * @generated from rpc raccoonai.DriverService.ListNearbyPickupLocations
   */
  listNearbyPickupLocations: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof PickupLocationListSchema;
  },
  /**
   * Start heading to a pickup location passed on the way: its jobs go ENROUTE
   * and everything already open stays open, unlike ChoosePickupLocation which
   * stands the previous location down. Rejects a location that is not among
   * ListNearbyPickupLocations.
   *
   * @generated from rpc raccoonai.DriverService.ServeNearbyPickupLocation
   */
  serveNearbyPickupLocation: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof JobListSchema;
  },
  /**
   * When arrived to pickup location and start performing service
   * (e.g., start cleaning container, or start disinfection).
   * Changes job status to ON_SERVICE
   *
   * @generated from rpc raccoonai.DriverService.StartServiceCurrentJob
   */
  startServiceCurrentJob: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * When finished performing service at pickup location and ready to leave.
   * Changes job status to COMPLETED, and if it's the last job in the route,
   * changes route status to RETURNING
   *
   * @generated from rpc raccoonai.DriverService.CompleteCurrentJob
   */
  completeCurrentJob: {
    methodKind: "unary";
    input: typeof CompleteCurrentJobRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * When driver is en-route back to the depot. Changes route status to RETURNING.
   * Any unfinished jobs in the route will be marked as NOT_COMPLETED and
   * recreated with same order number.
   *
   * @generated from rpc raccoonai.DriverService.ReturnToDepot
   */
  returnToDepot: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * When driver has arrived at the depot and completes the route. Changes route
   * status to COMPLETED
   *
   * @generated from rpc raccoonai.DriverService.CompleteCurrentRoute
   */
  completeCurrentRoute: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * Upload job-related file (e.g., photo evidence)
   *
   * @generated from rpc raccoonai.DriverService.UploadJobFile
   */
  uploadJobFile: {
    methodKind: "unary";
    input: typeof JobFileUploadRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Report a problem while on shift ("Сообщить о проблеме на линии").
   * Requires an active shift. Accepts shift-level incident types only
   * (TRUCK_BREAKDOWN, TRAFFIC_ACCIDENT, LOADERS_UNWELL, DRIVER_UNWELL, OTHER).
   * Notifies the dispatcher; no automatic route/job changes.
   *
   * @generated from rpc raccoonai.DriverService.ReportShiftIncident
   */
  reportShiftIncident: {
    methodKind: "unary";
    input: typeof ReportIncidentRequestSchema;
    output: typeof DriverIncidentSchema;
  },
  /**
   * Report a problem on the current job ("Сообщить о проблеме на задаче").
   * Requires an active route with a current job (ENROUTE or ON_SERVICE);
   * the backend resolves the job itself. Accepts all incident types.
   * For PICKUP_LOCATION_BLOCKED / PICKUP_LOCATION_NO_ACCESS /
   * UNSUITABLE_EQUIPMENT the jobs currently in progress are marked
   * NOT_COMPLETED (no copies are created — the dispatcher decides how to
   * handle the missed pickup) and the route advances to the next job as if
   * the job was completed; a route left with no assignable jobs moves to
   * RETURNING. Other types are notification-only.
   *
   * @generated from rpc raccoonai.DriverService.ReportJobIncident
   */
  reportJobIncident: {
    methodKind: "unary";
    input: typeof ReportIncidentRequestSchema;
    output: typeof DriverIncidentSchema;
  },
  /**
   * ******** Route Related RPCs *********** //
   *
   * @generated from rpc raccoonai.DriverService.AssignedRoutes
   */
  assignedRoutes: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof RouteListSchema;
  },
  /**
   * history of routes assigned to driver
   *
   * @generated from rpc raccoonai.DriverService.GetRouteHistory
   */
  getRouteHistory: {
    methodKind: "unary";
    input: typeof DateTimeFilterSchema;
    output: typeof RouteListSchema;
  },
  /**
   * update container's location
   *
   * @generated from rpc raccoonai.DriverService.UpdateContainerLocation
   */
  updateContainerLocation: {
    methodKind: "unary";
    input: typeof ContainerStatusUpdateSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * ******** Firebase Related RPCs *********** //
   * Subscribe or Unsubscribe
   *
   * @generated from rpc raccoonai.DriverService.FirebaseNotifications
   */
  firebaseNotifications: {
    methodKind: "unary";
    input: typeof FirebaseNotificationsRequestSchema;
    output: typeof FirebaseNotificationsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.DriverService.GetLocations
   */
  getLocations: {
    methodKind: "unary";
    input: typeof LocationListRequestSchema;
    output: typeof LocationListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_driver_service, 0);

